
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, Clock, Calendar, Building } from 'lucide-react';

interface StatsProps {
  totalEmployees: number;
  scheduledShifts: number;
  hoursScheduled: number;
  departments: number;
  upcomingTimeOffRequests: number;
  openShifts: number;
}

const Stats: React.FC<StatsProps> = ({
  totalEmployees,
  scheduledShifts,
  hoursScheduled,
  departments,
  upcomingTimeOffRequests,
  openShifts,
}) => {
  const stats = [
    {
      title: 'Medewerkers',
      value: totalEmployees,
      icon: Users,
      description: 'Totaal aantal medewerkers',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      title: 'Diensten',
      value: scheduledShifts,
      icon: Calendar,
      description: 'Ingeplande diensten deze week',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    {
      title: 'Uren',
      value: Math.round(hoursScheduled),
      icon: Clock,
      description: 'Ingeplande uren deze week',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
    },
    {
      title: 'Afdelingen',
      value: departments,
      icon: Building,
      description: 'Actieve afdelingen',
      color: 'text-amber-600',
      bgColor: 'bg-amber-50',
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat, index) => (
        <Card key={index} className="overflow-hidden transition-all hover:shadow-md">
          <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              {stat.title}
            </CardTitle>
            <div className={`p-2 rounded-full ${stat.bgColor}`}>
              <stat.icon className={`h-4 w-4 ${stat.color}`} />
            </div>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{stat.value}</div>
            <p className="text-xs text-muted-foreground mt-1">
              {stat.description}
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default Stats;
